export enum TaskItemStatus {
  Queued = 'queued',
  Started = 'started',
  Finished = 'finished',
  Failed = 'failed',
  Cancelled = 'cancelled',
}
